import { createRuntimeFn } from '@vanilla-extract/recipes/createRuntimeFn';

var innerStyle = 'toast-content_innerStyle__1hp4k8x1';
var rootStyle = 'toast-content_rootStyle__1hp4k8x0';
var slotRootStyle = createRuntimeFn({defaultClassName:'toast-content_slotRootStyle__1hp4k8x2',variantClassNames:{side:{left:'toast-content_slotRootStyle_side_left__1hp4k8x3',right:'toast-content_slotRootStyle_side_right__1hp4k8x4'}},defaultVariants:{},compoundVariants:[]});
var titleStyle = 'toast-content_titleStyle__1hp4k8x5';

export { innerStyle, rootStyle, slotRootStyle, titleStyle };
//# sourceMappingURL=toast-content.vanilla.mjs.map
